/**
 * Client-statement share totals — purchased / commission / bonus.
 * Display-only. Uses computeCanonicalBalances so totals tie to closing shares.
 */
import { computeCanonicalBalances } from './canonicalBalances.js'

const SHARE_EPS = 0.0001
const num = (v) => (typeof v === 'number' ? v : parseFloat(v ?? 0)) || 0
const round4 = (n) => +(Number(n) || 0).toFixed(4)

export function auditDataToCanonicalRaw(data) {
  const sp = data?.share_purchases || {}
  const ce = data?.commissions_earned || {}
  const cc = data?.commission_conversions || {}
  const w = data?.withdrawals || {}
  const st = data?.share_transfers || {}
  return {
    purchases: sp.all || [],
    commissionTransactions: ce.commission_transactions || [],
    multiLevelCommissions: ce.multi_level_commissions || [],
    conversions: cc.rows || [],
    withdrawalsExecuted: w.commission_withdrawals || [],
    withdrawalRequests: w.commission_withdrawal_requests || [],
    transfersSent: st.sent || [],
    transfersReceived: st.received || [],
    commissionBalance: data?.commission_balance || null,
  }
}

export function buildStatementShareTotals(data) {
  const c = computeCanonicalBalances(auditDataToCanonicalRaw(data))
  const b = c.breakdown
  const purchased = round4(b.displayPaidShares)
  const commission = round4(
    b.commissionLevelShares + b.performancePoolShares + b.acresRedemptionShares,
  )
  const bonus = round4(b.displayBonusShares)
  const totalOwned = round4(c.equityShares)
  const other = round4(totalOwned - purchased - commission - bonus)
  const walletUnconverted = round4(num(data?.commission_balance?.share_balance))
  return {
    purchased,
    commission,
    bonus,
    other: Math.abs(other) < SHARE_EPS ? 0 : other,
    totalOwned,
    walletUnconverted: Math.abs(walletUnconverted) < SHARE_EPS ? 0 : walletUnconverted,
  }
}
